// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Fb","heading":"Gb"};